import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {TranslateModule} from '@ngx-translate/core';
import {FontConfigsComponent} from '../../sidebar/shared/font-configs/font-configs.component';
import {EditorRegistryService} from 'src/app/diagram-render/mx-graph/editor/editor-registry.service';
import {MaterialModule} from 'src/app/material.module';
import {TextFormattingService} from '../../services/text-formatting.service';
import {MxCell} from '../../shared/models/mx-cell.interface';
import {DraggableDialogDirective} from '../../shared/directives/draggable-dialog.directive';

@Component({
  selector: 'app-change-font-dialog',
  templateUrl: './change-font-dialog.component.html',
  standalone: true,
  imports: [FontConfigsComponent, MaterialModule, TranslateModule, DraggableDialogDirective]
})
export class ChangeFontDialogComponent implements OnInit, OnDestroy {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {cell: MxCell},
    private editorRegistry: EditorRegistryService,
    private textFormattingSvc: TextFormattingService
  ) {
    this.graph.startEditingAtCell(this.data.cell);
  }
  public readonly shapeJson = {style: {}};
  private readonly graph = this.editorRegistry.getGraph();

  ngOnInit(): void {
    this.textFormattingSvc._refreshFontInfo(this.shapeJson);
  }

  ngOnDestroy(): void {
    this.graph.stopEditing(false);
  }

  setFontColor(colorHex: string) {
    this.textFormattingSvc.setFontColor(colorHex);
  }

  setFontStyle(event) {
    this.textFormattingSvc.setFontStyle(event);
  }

  toggleUnorderedList() {
    this.textFormattingSvc.toggleUnorderedList();
  }

  toggleOrderedList() {
    this.textFormattingSvc.toggleOrderedList();
  }

  get buttonsEnabled() {
    return this.textFormattingSvc.buttonsEnabled;
  }
}
